import { render, staticRenderFns } from "./BlockPrint.vue?vue&type=template&id=46cd7e9b"
import script from "./BlockPrint.vue?vue&type=script&lang=js"
export * from "./BlockPrint.vue?vue&type=script&lang=js"
import style0 from "./BlockPrint.vue?vue&type=style&index=0&id=46cd7e9b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports